var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.post)?_c('div',[_c('rich-text',{attrs:{"content-string":_vm.post.content}}),_c('user-button',{attrs:{"user-i-d":_vm.post.author}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }